import { Navigate, useLocation } from 'react-router-dom';
import { getAuthToken } from '@/services/api';
import { useCurrentUser } from '@/hooks/useQueries';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'admin' | 'staff';
}

export default function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const location = useLocation();
  const token = getAuthToken();
  const { data: userData, isLoading, error } = useCurrentUser();

  // Show loading state while verifying auth/role
  if (isLoading || (!token && !error)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#50b3e1]"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated or account inactive
  const isAuthenticated = token && userData && (!userData.status || userData.status === 'active');
  if (!isAuthenticated || error) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect to dashboard if user doesn't have the required role
  if (requiredRole && userData?.role !== requiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}

